import { Connection } from '@solana/web3.js';

export const SOLANA_WS_ENDPOINT =
  'wss://frequent-delicate-morning.solana-devnet.quiknode.pro/0a2fa7b2740d751f9ee8358ad7fc109633d4e17a/';

export const SOLANA_HTTP_ENDPOINT = SOLANA_WS_ENDPOINT.replace(/^wss:/, 'https:').replace(
  /^ws:/,
  'http:'
);

const sharedConnection = new Connection(SOLANA_HTTP_ENDPOINT, {
  commitment: 'confirmed',
  wsEndpoint: SOLANA_WS_ENDPOINT,
});

export function getSolanaConnection() {
  return sharedConnection;
}
